import React, { useState, useRef } from "react";
import {
    DialogTitle,
    DialogContent,
    Typography,
    Grid,
    Box,
    FormControlLabel,
    Switch
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";
import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import LinkDetectionTextField from "../utils/CommonComonents/LinkDetectionTextField";
import moment from "moment";
import Button from "@mui/material/Button";
import { auditOrderNotesUpdate } from "../modules/Audit";

const useStyles = makeStyles({
    notesInput: {
        borderColor: "initial",
        transition: "border-color 0.3s",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid black"
        },
        "&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
            /* border: "1px solid rgba(0, 135, 238, 0.66)",
            backgroundColor: "rgba(0, 135, 238, 0.12)" */
            border: "1px solid black"
        },
        "&.MuiInputLabel-root": {
            display: "none"
        },
        "& fieldset": {
            "& legend": {
                width: "unset"
            }
        }
    },
    mainButtonContainer: {
        padding: "10px 0px"
    },
    leftButtonContainer: {
        display: "flex",
        gap: "12px"
    },
    rightButtonContainer: {
        display: "flex",
        justifyContent: "flex-end"
    },
    saveButton: {
        color: "white",
        borderRadius: "4px",
        padding: "6px 42px",
        border: "none",
        cursor: "pointer",
        fontSize: "16px",
        height: "32px"
    },
    cancelButton: {
        cursor: "pointer",
        color: "rgb(0,0,0,0.8)",
        height: "32px"
    },
    clearButton: {
        cursor: "pointer",
        color: "#FF681D",
        paddingRight: "0px",
        justifyContent: "right",
        height: "32px"
    },
    notesUpdateText: {
        fontSize: "12px",
        fontStyle: "italic",
        color: "#5d5d5d",
        paddingTop: "4px"
    }
});

function BookingNotesDialog(props) {
    const [notes, setNotes] = useState(
        props.noteDialogContent.notes ? props.noteDialogContent.notes : ""
    );
    const [originalNotes, setOriginalNotes] = useState(
        props.noteDialogContent.notes ? props.noteDialogContent.notes : ""
    );
    const [bookingNotes, setBookingNotes] = useState(props.noteDialogContent);
    const [applyNotesToOrder, setApplyNotesToOrder] = useState(false);
    const [updatedAt, setUpdatedAt] = useState(
        props.noteDialogContent ? props.noteDialogContent.updatedAt : ""
    );
    const [updatedBy, setUpdatedBy] = useState(
        props.noteDialogContent ? props.noteDialogContent.updatedBy : ""
    );

    const classes = useStyles();

    const getBookingsByOrderId = async () => {
        try {
            let result = await graphql(
                graphqlOperation(queries.bookingByOrder, {
                    orderId: props.noteOrderNumber
                })
            );

            let bookingsInOrder = result.data.bookingByOrder.items;
            return bookingsInOrder;
        } catch (error) {
            console.error("Error fetching bookings by order:", error);
            return [];
        }
    };

    const updateBookingsInOrder = async () => {
        try {
            const bookingsToUpdate = await getBookingsByOrderId();

            // Loop through each booking and delete its notes
            for (const booking of bookingsToUpdate) {
                const bookingInput = {
                    id: booking.id,
                    Notes: null
                };

                const bookingResult = await graphql(
                    graphqlOperation(mutations.updateBooking, {
                        input: bookingInput
                    })
                );

                console.log("Updated booking:", bookingResult);
            }

            console.log("All bookings updated successfully.");
        } catch (error) {
            console.error("Error updating bookings:", error);
        }
    };

    const handleNotesChange = (event) => {
        const newText = event.target.value;
        setNotes(newText);
    };

    const handleCancel = () => {
        props.onClose();
    };

    const handleClear = () => {
        setNotes("");
    };

    const saveBookingNotes = async () => {
        document.activeElement.blur(); // Unfocus the text field
        setOriginalNotes(notes);
        setUpdatedBy(
            props.loggedInUser.firstname + " " + props.loggedInUser.lastname
        );
        setUpdatedAt(moment().format("YYYY-MM-DD HH:mm"));
        let newNotes = {};
        const date = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        try {
            if (bookingNotes) {
                //if Notes exists, then only update and use the same createdAt and createdBy attributes
                newNotes = {
                    notes: notes.trim(),
                    createdBy: bookingNotes.createdBy,
                    updatedBy:
                        props.loggedInUser.firstname +
                        " " +
                        props.loggedInUser.lastname,
                    createdAt: bookingNotes.createdAt,
                    updatedAt: date
                };
                setBookingNotes(newNotes);
            } else {
                //if Notes dont exists, add new created stamps and update stamps
                newNotes = {
                    notes: notes.trim(),
                    createdBy:
                        props.loggedInUser.firstname +
                        " " +
                        props.loggedInUser.lastname,
                    updatedBy:
                        props.loggedInUser.firstname +
                        " " +
                        props.loggedInUser.lastname,
                    createdAt: date,
                    updatedAt: date
                };
                setBookingNotes(newNotes);
            }

            if (!applyNotesToOrder) {
                const bookingInput = {
                    id: props.rowBookingId,
                    Notes: JSON.stringify([
                        {
                            createdBy:
                                props.loggedInUser.firstname +
                                " " +
                                props.loggedInUser.lastname,
                            createdAt: date,
                            notes: newNotes.notes
                        }
                    ])
                };

                const bookingResult = await graphql(
                    graphqlOperation(mutations.updateBooking, {
                        input: bookingInput
                    })
                );

                console.log("Updated booking:", bookingResult);

                props.onSaveNotes(
                    applyNotesToOrder,
                    props.rowBookingId,
                    JSON.stringify([
                        {
                            createdBy:
                                props.loggedInUser.firstname +
                                " " +
                                props.loggedInUser.lastname,
                            createdAt: date,
                            notes: newNotes.notes
                        }
                    ])
                );

                props.onClose();
            } else {
                updateBookingsInOrder();

                const orderInput = {
                    id: props.noteOrderNumber,
                    Notes: JSON.stringify([newNotes])
                };
                const orderResult = await graphql(
                    graphqlOperation(mutations.updateOrder, {
                        input: orderInput
                    })
                );

                props.onSaveNotes(
                    applyNotesToOrder,
                    props.noteOrderNumber,
                    JSON.stringify([newNotes])
                );

                props.onClose();

                if (
                    orderResult &&
                    orderResult.data &&
                    orderResult.data.updateOrder
                ) {
                    try {
                        await auditOrderNotesUpdate(
                            props.loggedInUser,
                            orderResult.data.updateOrder,
                            props.rowBookingId,
                            notes,
                            originalNotes,
                            "ORDER_NOTES"
                        );
                    } catch (e) {
                        console.log("Error while entering audit");
                    }
                }
            }
        } catch (e) {
            console.log("ERROR: Unable to save Booking notes ", e);
        }
    };

    return (
        <>
            <DialogTitle sx={{ color: "#000000", opacity: "0.75" }}>
                Note
            </DialogTitle>
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingBottom: "0px"
                }}
            >
                <Box sx={{ paddingBottom: "16px" }}>
                    <Typography>
                        <b>Customer: </b>
                        {props.noteClientName}
                    </Typography>
                    <Typography>
                        <b>Service: </b>
                        {props.noteServiceName}
                    </Typography>
                    <Typography>
                        <b>Start date: </b>
                        {props.noteBookingStartDate}
                    </Typography>
                </Box>
                <LinkDetectionTextField
                    label="Booking notes"
                    labelWidth="80px"
                    value={notes}
                    onChange={(newValue) => setNotes(newValue)}
                    shouldAutofocus={true}
                />
                <Grid item xs={12} sm={12} direction={"row"}>
                    <FormControlLabel
                        sx={{ marginBottom: "0px" }}
                        control={
                            <Switch
                                checked={applyNotesToOrder}
                                onChange={() =>
                                    setApplyNotesToOrder(!applyNotesToOrder)
                                }
                                name="bookingNotes"
                            />
                        }
                        label="Apply to each session in this order and replace existing notes"
                    />
                </Grid>
                {updatedBy && (
                    <Grid container item xs={12}>
                        <Typography className={classes.notesUpdateText}>
                            Last edited by {updatedBy} on{" "}
                            {moment(updatedAt).format("YYYY-MM-DD HH:mm")}
                        </Typography>
                    </Grid>
                )}
                <Grid
                    container
                    item
                    xs={12}
                    className={classes.mainButtonContainer}
                >
                    <Grid item xs={4} className={classes.leftButtonContainer}>
                        <Button
                            onClick={saveBookingNotes}
                            variant="contained"
                            className={classes.saveButton}
                            disabled={notes === originalNotes ? true : false}
                        >
                            <Typography
                                variant="button"
                                style={{
                                    textTransform: "none"
                                }}
                            >
                                {`Save`}
                            </Typography>
                        </Button>
                        <Button
                            onClick={handleCancel}
                            variant="text"
                            className={classes.cancelButton}
                        >
                            {
                                <Typography
                                    variant="button"
                                    style={{
                                        textTransform: "none"
                                    }}
                                >
                                    {`Cancel`}
                                </Typography>
                            }
                        </Button>
                    </Grid>
                    <Grid item xs={8} className={classes.rightButtonContainer}>
                        <Button
                            onClick={handleClear}
                            variant="text"
                            className={classes.clearButton}
                        >
                            <Typography
                                variant="button"
                                style={{
                                    textTransform: "none"
                                }}
                            >
                                {`Clear`}
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </>
    );
}

export default BookingNotesDialog;
